import {RECEIVE_TEXT_CONTENT} from '../actions/action-types';

export default (state = {}, {type, payload}) => {
    switch (type) {
        case RECEIVE_TEXT_CONTENT:
            return {
                ...state,
                ...payload,
            };
        default:
            return state;
    }
};
